import Work5 from '../../assets/work6.png'
import Work6 from '../../assets/work7.webp'
import Work7 from '../../assets/work8.webp'

export const projectsData = [
  // {
  //   id: 1,
  //   image: Work1,
  //   title: 'Omnifood Project',
  //   stack: ['HTML', 'CSS', 'JavaScript'],
  //   demourl: 'https://mav-omnifood.netlify.app/',
  //   sourceurl: 'https://github.com/hifly3082/omnifood'
  // },
  // {
  //   id: 2,
  //   image: Work2,
  //   title: 'Fitness Club',
  //   stack: ['JavaScript', 'React', 'Material UI'],
  //   demourl: 'https://mav-gym-exercises.netlify.app/',
  //   sourceurl: 'https://github.com/hifly3082/gym-exercises'
  // },
  // {
  //   id: 3,
  //   image: Work3,
  //   title: 'YouTube Clone',
  //   stack: ['JavaScript', 'React', 'Material UI'],
  //   demourl: 'https://mav-youtube.netlify.app/',
  //   sourceurl: 'https://github.com/hifly3082/youtube-like'
  // },

  {
    id: 1,
    image: Work6,
    title: 'E-commerce app',
    stack: ['React', 'TS', 'Redux', 'RTK Query', 'styled'],
    demourl: 'https://mavshop.netlify.app/',
    sourceurl: 'https://github.com/hifly3082/e-commerce-app'
  },
  {
    id: 2,
    image: Work7,
    title: 'Next blog',
    stack: ['Next.js', 'TypeScript', 'SCSS'],
    demourl: 'https://next-blog-mav.vercel.app/',
    sourceurl: 'https://github.com/hifly3082/next-blog'
  },
  {
    id: 3,
    image: Work5,
    title: 'Todo app',
    stack: ['React', 'TS', 'easy-peasy', 'Ant Design'],
    sourceurl: 'https://github.com/hifly3082/to-do-app'
  }
  // {
  //   id: 3,
  //   image: Work4,
  //   title: 'User list app',
  //   stack: ['React', 'TS', 'Redux', 'RTK query'],

  //   sourceurl: 'https://github.com/hifly3082/user-list-app'
  // }
]

// export const projectsNav = [
//   {
//     name: 'all'
//   },
//   {
//     name: 'HTML'
//   },
//   {
//     name: 'CSS'
//   },
//   {
//     name: 'JavaScript'
//   },
//   {
//     name: 'React'
//   }
// ]
